export class ExpedicaoNaoLiberadoSearch {
    id: number;
    numeroErp: string;
    tipoVenda: number;
    quantidadeVolumesPrevistos: number;

    // Local de Faturamento
    idLocalFaturamento: number;
    codigoIntegracaoErpLocalFaturamento: string;
    nomeLocalFaturamento: string;

    constructor(props: Partial<ExpedicaoNaoLiberadoSearch>) {
        Object.assign(this, props);
    }
}
